import { useQuery } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import { type UserBasicDto } from '@/api/generated/models/user-basic-dto';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { type RefetchModel } from '@/api/model/Refetch.model.ts';
import { ensureCurrentUser } from '@/contexts/userContext/currentUserSnapshot.util.ts';

type Return = {
  currentUser: UserBasicDto | undefined;
  getCurrentUser: RefetchModel<UserBasicDto>;
  isGettingCurrentUser: boolean;
};

export const useGetCurrentUser = (params: { pathWithoutSession: boolean }): Return => {
  const { data, fetchStatus, isLoading, refetch } = useQuery<UserBasicDto, AxiosError>({
    enabled: !params.pathWithoutSession,
    // Shared with the route guard loaders so a cold start fetches once (OCD-309).
    queryFn: ensureCurrentUser,
    queryKey: [QueryKeyEnum.CURRENT_USER],
  });
  return {
    currentUser: data,
    getCurrentUser: refetch,
    isGettingCurrentUser: fetchStatus !== 'idle' && isLoading,
  };
};
